// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedFile{border:2px solid #f90}.file_text .ivu-input{color:#aaa}", ""]);
// Exports
module.exports = exports;
